import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import SalesOrderProcessInfoTable from './SalesOrderProcessInfoTable'
import SalesOrderPriceTable from '../detail/SalesOrderPriceTable'
import SalesOrderPaymentDetails from '../detail/SalesOrderPaymentDetails'
import currentUserHasAccess from '../../../../util/widget-helper'
import FreshSalesInfoTable from './FreshSalesInfoTable';
import {SALES_ORDER_OVERVIEW_WIDGET} from '../../../process/ui-definition/process-ui'

/* this is used within the process */
const SalesOrderOverviewWidget = ({salesOrder, dealOwner,calendlyLink, showInitialProcess, hasPreviousRetainerRefinementProcess }) => {
    if (!currentUserHasAccess(SALES_ORDER_OVERVIEW_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Overview ">
            <Row>
                <Column size={3}>
                    <SalesOrderProcessInfoTable
                        salesOrder={salesOrder}
                        showInitialProcess={showInitialProcess}
                        hasPreviousRetainerRefinementProcess={hasPreviousRetainerRefinementProcess}
                    />
                </Column>
                {dealOwner && (
                    <Column size={3}>
                        <FreshSalesInfoTable
                            dealOwner={dealOwner}
                            calendlyLink={calendlyLink}
                        />
                    </Column>
                )}
                <Column size={3}>
                    <SalesOrderPaymentDetails salesOrder={salesOrder}/>
                </Column>
                <Column size={3}>
                    <SalesOrderPriceTable salesOrder={salesOrder}/>
                </Column>
            </Row>
        </ContentBox>
    )
}

SalesOrderOverviewWidget.propTypes = {
    salesOrder: PropTypes.object.isRequired,
    dealOwner: PropTypes.string,
    showInitialProcess: PropTypes.bool,
    hasPreviousRetainerRefinementProcess: PropTypes.bool,
}

export default SalesOrderOverviewWidget




// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SalesOrderOverviewWidget.js